import {
    startOfMonth,
    endOfMonth,
    startOfWeek,
    endOfWeek,
    addDays,
    addMonths,
    subMonths,
    isSameMonth,
    isToday,
    isSameDay,
} from "date-fns";
import { computed, ref } from "vue";

export function useCalendar() {
    const today = new Date();
    const currentMonth = ref(new Date());

    const days = computed(() => {
        const start = startOfWeek(startOfMonth(currentMonth.value), {
            weekStartsOn: 1,
        });
        const end = endOfWeek(endOfMonth(currentMonth.value), {
            weekStartsOn: 1,
        });
        const dayList: Date[] = [];

        let date = start;
        while (date <= end) {
            dayList.push(date);
            date = addDays(date, 1);
        }

        return dayList;
    });

    function nextMonth() {
        currentMonth.value = addMonths(currentMonth.value, 1);
    }

    function prevMonth() {
        currentMonth.value = subMonths(currentMonth.value, 1);
    }

    return {
        today,
        currentMonth,
        days,
        nextMonth,
        prevMonth,
        isSameMonth,
        isToday,
        isSameDay,
    };
}
